import React from "react";

import { FieldSeparator } from "App/styles";

import {
  Container,
  MainSection,
  CardMainText,
  CardSecondaryText,
  Details,
} from "basics/cards";
import ItemCardToolBar from "components/ItemCardToolBar";
import NewsItemIcon from "icons/NewsItemIcon";

export default function NewsItemCard({
  item,
  selected,
  onSelectEditedItem,
  onSelectDeletedItem,
  onCleanItemId,
}) {
  return (
    <Container selected={selected}>
      <MainSection>
        <NewsItemIcon />
        <Details>
          <CardMainText>{item.title}</CardMainText>
          <FieldSeparator />
          <CardSecondaryText weight="bold">{item.date}</CardSecondaryText>
        </Details>
      </MainSection>

      <ItemCardToolBar
        id={item.id}
        actived={item.actived}
        selected={selected}
        onCleanItemId={onCleanItemId}
        onSelectEditedItem={onSelectEditedItem}
        onSelectDeletedItem={onSelectDeletedItem}
      />
    </Container>
  );
}
